import React, { useState } from "react";
import api, { fmtErr } from "../../lib/api";
import { fmtEUR, fmtDate } from "../../lib/format";
import { Button } from "../ui/button";
import { Badge } from "../ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../ui/select";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";

const NUOVA = "__nuova__"; const NESSUNA = "__nessuna__";

export default function BudgetAiDialog({ operationId, onApplied }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [data, setData] = useState(null);
  const [scelte, setScelte] = useState({});

  const avvia = async (anche) => {
    setBusy(true); setOpen(true);
    try {
      const r = await api.post(`/operations/${operationId}/budget/collega-ai`, { anche_gia_abbinate: !!anche });
      setData(r.data);
      const s = {}; (r.data.proposte || []).forEach((p) => { s[p.invoice_id] = p.budget_item_id || (p.nuova_voce ? NUOVA : NESSUNA); }); setScelte(s);
      if (!r.data.proposte?.length) toast.message(r.data.messaggio || "Nessuna fattura da abbinare");
    } catch (e) { toast.error(fmtErr(e.response?.data?.detail)); setOpen(false); } finally { setBusy(false); }
  };
  const applica = async () => {
    const proposte = (data?.proposte || []).filter((p) => scelte[p.invoice_id] !== NESSUNA).map((p) => ({ invoice_id: p.invoice_id, budget_item_id: scelte[p.invoice_id] === NUOVA ? null : scelte[p.invoice_id], nuova_voce: scelte[p.invoice_id] === NUOVA ? p.nuova_voce : null }));
    if (!proposte.length) return toast.error("Nessuna proposta selezionata");
    try { const r = await api.post(`/operations/${operationId}/budget/applica-proposte`, { proposte }); toast.success(`${r.data.collegate} fatture abbinate${r.data.voci_create ? `, ${r.data.voci_create} voci nuove` : ""}`); setOpen(false); setData(null); onApplied?.(); }
    catch (e) { toast.error(fmtErr(e.response?.data?.detail)); }
  };
  const conf = (c) => c >= 80 ? "bg-emerald-600" : c >= 50 ? "bg-amber-500" : "bg-slate-400";

  return (
    <>
      <Button size="sm" variant="outline" onClick={() => avvia(false)} disabled={busy} data-testid="budget-ai-btn"><Sparkles className="w-4 h-4 mr-1 text-amber-500" /> Abbina fatture con AI</Button>
      <Dialog open={open} onOpenChange={(o) => !o && setOpen(false)}>
        <DialogContent className="max-w-5xl max-h-[85vh] overflow-y-auto">
          <DialogHeader><DialogTitle>Abbinamento fatture → voci di budget (proposte AI)</DialogTitle></DialogHeader>
          {busy && <div className="text-sm text-muted-foreground py-6 text-center">L'AI sta leggendo le fatture dell'operazione…</div>}
          {!busy && data && (
            <div className="space-y-2" data-testid="budget-ai-proposte">
              <div className="flex justify-between items-center text-xs text-muted-foreground"><span>{data.proposte.length} fatture · scegli la voce o «nuova voce» / «non abbinare», poi Applica.</span><Button size="sm" variant="ghost" onClick={() => avvia(true)}>Rianalizza anche quelle già abbinate</Button></div>
              {data.proposte.map((p) => (
                <div key={p.invoice_id} className="border rounded-md p-2 grid grid-cols-1 md:grid-cols-[1fr_320px] gap-2 items-start" data-testid="budget-ai-row">
                  <div className="text-sm">
                    <div className="font-medium">Fatt. {p.numero} · {p.fornitore} <span className="kpi-num">{fmtEUR(p.importo)}</span> <span className="text-xs text-muted-foreground">{p.data ? fmtDate(p.data) : ""}</span></div>
                    <div className="text-xs text-muted-foreground line-clamp-2">{p.oggetto}</div>
                    <div className="text-xs mt-1"><Badge className={`${conf(p.confidenza)} text-[10px] mr-1`}>{p.confidenza}%</Badge>{p.motivo}</div>
                  </div>
                  <Select value={scelte[p.invoice_id]} onValueChange={(v) => setScelte({ ...scelte, [p.invoice_id]: v })}>
                    <SelectTrigger className="h-9 text-xs" data-testid="budget-ai-select"><SelectValue /></SelectTrigger>
                    <SelectContent>
                      {p.nuova_voce && <SelectItem value={NUOVA}>➕ Nuova voce: {p.nuova_voce.voce} ({p.nuova_voce.categoria})</SelectItem>}
                      {data.voci.map((v) => <SelectItem key={v.id} value={v.id}>{v.voce} · {v.categoria}</SelectItem>)}
                      <SelectItem value={NESSUNA}>— Non abbinare —</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
              ))}
            </div>
          )}
          <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Chiudi</Button><Button onClick={applica} disabled={busy || !data?.proposte?.length} data-testid="budget-ai-apply">Applica abbinamenti</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
